import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";

import themeColors, { themeFonts, themeFontsSize, themeFontWeights } from "@GeriMed/styles/variables";
import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideHeader,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";
import { css } from "styled-components";

export interface HomePageStyles {
    page?: MobiusPageProps;
}

export const homePageStyles: HomePageStyles = {
    page: {
        css: css`
        //homepage
            .home-heading {
                width: 100%;
                border-bottom: 8px solid ${themeColors.crosssellBorderColor};
                text-align: center;
                line-height: 100%;
                clear: both;

                h2 {
                    font-size: ${themeFontsSize.size175};
                    background: none repeat scroll 0% 0% ${themeColors.colorWhite};
                    width: auto;
                    display: inline-block;
                    padding: 0 .5em;
                    position: relative;
                    margin: 20px 0 -14px;
                    vertical-align: bottom!important;
                    line-height: ${themeFontsSize.size75};
                }

                &:last-child {
                    margin: 0 auto;
                }
            }
            .product-slider img{
                min-width: 160px;
                min-height: 160px;
            }
            .products-wrap .home-heading{
                width: 100%;
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                    .products-wrap .home-heading{
                        width: 90%;
                    }
                    .service-section,.learn-more-container{
                        [class*="GridItemStyle"] {
                            flex-basis: 33.33%;
                            max-width: 33.33%;
                        }
                    }
                    .home-heading {
                        h2 {
                            line-height: ${themeFontsSize.size26};
                        }
                    }
                    `,
                ],
                "max",
            )}

            @media screen and (max-width: 1024px) {
                .brands-wrap .img-wrapper {
                    padding: 0 15px 30px 15px;
                }
            }
            @media screen and (max-width: 640px) {
                .service-section,.learn-more-container{
                    [class*="GridItemStyle"] {
                        flex-basis: 100%;
                        max-width: 100%;
                        margin-bottom: 20px;
                    }
                }
            }

            .img-container {
                border: 1px solid ${themeColors.colorDarkgray};
                border-radius: 10px;
                overflow: hidden;
                padding: 15px 0;
                background: ${themeColors.colorWhite};
            }

            .services-content {
                display: flex;
                flex-direction: column;
                text-align:center
                overflow: hidden;
            }

            .marketing-title,.heading-content,.img-wrapper {
                margin: 0 auto;
                max-width: 1024px;
                padding-bottom: 30px;
                width: 100%;
                display: block;
            }

            @media screen and (min-width: 768px) and (max-width: 1024px){
                .heading-content{
                    width: 80%;
                }   
            }

            .field-title {
                display: block;
                color: ${themeColors.lightBlue};
                font-family: ${themeFonts.fontFamilyProximaNova}; 
                font-weight: ${themeFontWeights.medium};
                font-size: ${themeFontsSize.size175};
                margin-bottom: 8px;
            }
            
            .field-description {
                display: block;
                color: ${themeColors.lightBlack};
                font-family: ${themeFonts.fontFamilyProximaNova};
                font-size: ${themeFontsSize.size15em};
                line-height: 1;
            }
            .field-title,.field-description {
                text-align: center;
            }
            
             .services-info {
                padding-top: 30px;
                padding-bottom: 60px;
                background: ${themeColors.colorLightgray};
                border-radius: 0 0 8px 8px;
            }
            
            .services-section{
                img {
                    margin: 20px auto;
                    width: 100%;
                    height: auto;
                    max-width: fit-content;

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                max-width: 210px;
                                max-height: 135px;
                            `,
                        ],
                        "max",
                    )}
                }
    
                [class*="GridOffset"]{
                    max-width:1024px;
                    margin:0 auto 
                }
            } 
            
            .services-wrap {
                background: ${themeColors.colorWhite};
                border: 1px solid ${themeColors.colorDarkgray};
                border-radius: 10px;
                margin: 30px 15px 0 15px;
            }

            //marketing section
            .marketing-wrap {
                padding: 0 0 30px 0 !important;
                background: ${themeColors.colorBluish};

                .heading-content{
                    padding-bottom: 0;
                }
            }

            .learn-more-container {
                [data-test-selector="GridItemStyle"]{
                    padding: 0 15px;
                }
                [class*="GridItemStyle"] {
                    padding: 0 15px;
                }
                .img-wrapper {
                    padding-bottom: 0;
                }
                [class*="GridOffset"] {
                    margin: 0 auto;
                    max-width: 1024px;
                    width: 100%;
                }
            } 
            

            .offer-info {
                padding:24px 0;
                text-align: center;
            }
            .who-we-serve-title .offer-info{
                padding: 0 0;
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                    .offer-info {
                        h4,p{
                            padding:0;
                        }
                    }
                    .services-wrap {
                        margin: 0 15px 0 15px;
                    }
                    `,
                ],
                "max",
            )}
            
            .offer-info{
                h4{
                    font-weight: ${themeFontWeights.bold};
                    font-size: ${themeFontsSize.size28};
                    line-height: 32px;
                    margin-bottom: 16px;
                    font-family: ${themeFonts.fontFamilyArial};
                }
                p{
                    font-size: ${themeFontsSize.size18};
                    line-height: 24px;
                    color: ${themeColors.dimBlack};
                    margin-bottom: 0;
                }
            } 
            .btn.view-deatils{
                width:100%;
            }
        `,
    }
};
const styles = homePageStyles;

const HomePage = ({ id }: PageProps) => (
    <Page data-test-selector="homePage" {...styles.page}>
        <Zone contentId={id} zoneName="Content" requireRows />
        <Modals />
    </Page>
);

const pageModule: PageModule = {
    component: HomePage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "System",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            {
                ...StructuredPageData,
                tooltip:
                    "Code entered in this field will be added to the head of the home page. This field only supports JSON-LD data.",
            },
            HideHeader,
            HideFooter,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "HomePage" instead of this constant.
 */
export const HomePageContext = "HomePage";
